import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import arrow from '../../../asset/icons/right_arrow.svg'
import GenericSubRow from './GenericSubRow'
import { mapMaker } from './RowComponents'
import { GreenCheckbox } from '../../CheckBox/GreenCheckbox'

export const GenericRow = props => {
  const refs = useRef({})
  useEffect(() => {
    const checkEllipsisText = () => {
      if (props.structure.showTooltip) {
        Object.keys(refs.current).forEach(key => {
          const element = refs.current[key]
          if (element) {
            const isEllipsisActive = el => el.scrollWidth > el.clientWidth
            if (isEllipsisActive(element)) {
              element.setAttribute('title', element.textContent)
            } else {
              element.removeAttribute('title')
            }
          }
        })
      }
    }
    checkEllipsisText()
    window.addEventListener('resize', checkEllipsisText)
    return () => {
      window.removeEventListener('resize', checkEllipsisText)
    }
  }, [props]) 
  

  const fillRow = rowContent => {
    const myMap = mapMaker(props.structure.headers, props.structure.dataKeys)
    const filler = []
    
    myMap.forEach((value, key) => {
      let classes = 'cell'
      if (props.structure.rowFormat?.[value]?.customStyle) {
        classes = props.structure.rowFormat[value].overwriteStyles
          ? props.structure.rowFormat[value].customStyle
          : `${classes} ${props.structure.rowFormat[value].customStyle}`
      }

      if (props.structure.rowFormat?.[value]?.format) {
        const allContent = props.structure.rowFormat[value].allContent

        filler.push(
          <div
            key={value}
            className={classes}
            ref={el => refs.current[value] = el}
          >
            {(value &&
              props.structure.rowFormat[value].format(
                props.replantOrLost?.[props.id]?.fieldLost
                  ? null
                  : allContent ? rowContent : rowContent[value]
              )) ||
              '-'}
          </div>
        )
      } else if (props.structure.rowFormat?.[value]?.clickable) {
        filler.push(
          <div key={key.value || key} className={classes}>
            <span
              className="modalLink"
              data={rowContent[value]}
              onClick={() =>
                props.structure.rowFormat[value].clickable(rowContent)
              }
              ref={el => refs.current[value] = el}
            >
              {props.structure.rowFormat[value].name(rowContent[value]) || '-'}
            </span>
          </div>
        )
      } else if (value) {
        filler.push(
          <div key={key.value || key} className={classes} ref={el => refs.current[value] = el}>
            {value && rowContent[value] ? rowContent[value] : '-'}
          </div>
        )
      }
    })

    return filler
  }

  const clickHandler = () => {
    if (props.handleClick) {
      props.handleClick(props.rowContent)
    }
  }

  const [selectedRow, setSelectedRow] = React.useState(false)

  const selectRow = (event, data) => {
    const catchNode = event.target.id
    const catchParentNode = event.target.parentNode.id

    if (catchNode === 'multipleScaleRow' || catchParentNode === 'multipleScaleRow') {
      setSelectedRow(true)
      props.structure.setAllSelectedRowsFunc(prev => {
        let findSameData = false

        if (prev.length) {
          prev.forEach(content => {
            if (content.id === data.id) {
              findSameData = true
              prev = prev.filter(contentData => contentData.id !== data.id)
              setSelectedRow(false)
            }
          })
        }

        if (!findSameData) {
          prev.push(data)
        }

        return [...prev]
      })
    }
  }

  const renderRow = () => {
    if (props.structure.hasSubRow) {
      return (
        <div
          className={`tableRow ${props.isActive ? 'selected' : ''}`}
          onClick={clickHandler}
        >
          <div className="primary">
            {props.structure.hasIcon && (
              <img
                data-testid="subrowArrow"
                src={arrow}
                className={`rowButton ${props.isActive ? 'down' : ''}`}
                alt="row arrow"
              />
            )}
            <div className="rowContent">
              {fillRow(props.rowContent)}
            </div>
          </div>
          {props.isActive && props.structure.hasSubRow && (
            <div className="subMenu">
              {renderSubMenu(props.rowContent.subRowContent)}
            </div>
          )}
        </div>
      )
    } else if (props.structure.isSelected) {
      const isChecked = props.structure.isSelected(props.rowContent)
      return (
        <div data-testid="generic_row" role="row" className="tableRow">
          <div className="primary">
            <div className="checkBox-container">
              <GreenCheckbox
                checked={isChecked}
                onChange={() =>
                  props.structure.toggleSelected(props.rowContent.reseller_id)
                }
                className="checkbox"
              />
            </div>
            <div className="rowContent">
              {fillRow(props.rowContent)}
            </div>
          </div>
        </div>
      )
    } else if (props.deleteMultipleScaleTickets) {
      return (
        <div
          data-testid="generic_row"
          id="multipleScaleRow"
          role="row"
          className={`pl16 df h48 dp aic bb1-s-lightgray ${props.customRowClass}`}
          onClick={e => selectRow(e, props)}
          style={{ backgroundColor: selectedRow ? 'rgb(151, 187, 241)' : 'white' }}
        >
          {fillRow(props.rowContent)}
        </div>
      )
    } else {
      return (
        <div
          data-testid="generic_row"
          role="row"
          className={`pl16 df h48 dp aic bb1-s-lightgray ${props.customRowClass}`}
          onClick={clickHandler}
        >
          {fillRow(props.rowContent)}
        </div>
      )
    }
  }

  const renderSubMenu = children => {
    return children.map((child, index) => (
      <GenericSubRow
        key={index}
        index={index}
        rowContent={child}
        structure={props.subRowStructure}
      />
    ))
  }

  return renderRow()
}

export default React.memo(GenericRow)

GenericRow.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowContent: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
  isActive: PropTypes.bool,
  TrialPlanSubRow: PropTypes.object
}
